import * as CommonActions from "./common"

export const ActionCreators = {
  ...CommonActions
};

export default ActionCreators;
